/*!
 *
 *	mainvis.js
 *
 */

var mainvis = function(){
	this.$feature = $('#feature');
	this.$bg = $('#feature_bg');
	this.$item = this.$bg.children();
	this.max = this.$item.length;

	var self = this;
	var _count = this.max;
	var preload = function(){
		for( var i=0; i<self.max; i++ ){
			var $img = $('<img />');
			var _src = '/dcms_media/image/top_main'+ (i+1) +'.jpg?' + Date.now();
			$img.attr('src',_src).on('load', function(){
				if( --_count > 0 ) return false;
				setTimeout(function(){
					start();
				}, 1000);
			});
		};
	};

	this.$active = this.$item.filter(':first-child');
	var count = 1;
	var start = function(){
		self.$feature.addClass('start');
		setTimeout(function(){
			fade();
		}, 1000);
	};

	var fade = function(){
		setTimeout(function(){
			count++;
			if( count > self.max ){
				count = 1;
			};
			var $next = this.$item.filter(':nth-child('+ count +')');
			$next.addClass('next');
			self.$active.fadeOut(1000, function(){
				self.$active.removeClass('active').show(0);
				$next.addClass('active').removeClass('next');
				self.$active = $next;
				fade();
			});
		}, 3000);
	};

	preload();
};

module.exports = mainvis;


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/mainvis.js
// module id = 17
// module chunks = 0